import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4400Model } from '../kymw4400.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PageInfo } from '../vo/page-info.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

// レスポンス構造
export type GetPageInfoListResponse = {
  PlanFixed: string;
  OriginalOrderCode: string;
  OriginalCoopCode: string;
  PageList: {
    PageId: string;
    PageNum: string;
    Folio: string;
    PageInfo: string;
    WebCatalogTitle: string;
    PageTemplateId: string | null;
    ContactUser1: string;
    ContactUser2: string;
    ContactUser3: string;
    Feature1: string;
    Feature2: string;
    Feature3: string;
    AutoArrangePattern: string;
    CommonPublishFlg: string;
    PublishGoodsGroupIdList: string[];
    TagIdList: string[];
  }[];
};

/**
 * ページ一覧取得サービス
 * @export GetPageInfoListService
 * @class GetPageInfoListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPageInfoListService extends PlessJsonResponderSub<GetPageInfoListResponse> {
  model: KYMW4400Model;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPageInfoListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
        CoopCode: this.model.coopCode,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPageInfoListService
   */
  execute(
    model: KYMW4400Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    // クリア
    this.model.pageList = [];
    this.model.pageListOrigin = [];
    this.model.isEditable = false;
    this.model.searchedMediumType = '';
    this.model.searchedOrderCode = '';
    this.model.searchedCatalogId = '';
    this.model.searchedCoopCode = '';

    this.succeed = s;
    this.fail = f;
    this.send('getPageInfoList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPageInfoListService
   */
  success(data: GetPageInfoListResponse) {
    data.PageList.forEach(_p => {
      this.model.pageList.push(new PageInfo(_p));
      this.model.pageListOrigin.push(new PageInfo(_p));
    });
    this.model.pageList.forEach(_ => {
      _.setPublishGoodsGroupName(this.model.publishGoodsGroupSelectItems);
      _.setTagName(this.model.tagSelectItems);
      _.pageTemplateId = PlessViewUtilsSub.isEmpty(_.pageTemplateId) ? KYMW4400Model.PAGE_TEMPLATE_AUTOSELECT: _.pageTemplateId;
    });
    this.model.setPlanFixed(data.PlanFixed);
    
    // コピー元パラメータ保存
    this.model.originalOrderCode = data.OriginalOrderCode;
    this.model.originalCoopCode = data.OriginalCoopCode;

    // 一覧取得時のパラメータ保存
    this.model.searchedMediumType = this.model.mediumType;
    this.model.searchedOrderCode = this.model.orderCode;
    this.model.searchedCatalogId = this.model.catalogId;
    this.model.searchedCoopCode = this.model.coopCode;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW4400Model): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    if (status === 'plessError' && result?.errorcode === 'E0100') {
      // E0100許容
      this.model.searchedMediumType = this.model.mediumType;
      this.model.searchedOrderCode = this.model.orderCode;
      this.model.searchedCatalogId = this.model.catalogId;
      this.model.searchedCoopCode = this.model.coopCode;
      this.model.isEditable = true;

      super.statusError(status, result);
      if (this.succeed) this.succeed();
      return;
    }
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
